document.addEventListener("DOMContentLoaded", function() {
    var header = document.querySelector("#header");
    var siteNavigationSingle = document.querySelector(".single .site-navigation");
    var siteNavigationCategory = document.querySelector(".category .site-navigation");
	var icon = document.querySelector('#header .site-navigation .inner .opener');
	if (icon) {
		icon.addEventListener('click', function() {
			const isBgColor002054 = window.getComputedStyle(document.querySelector('.site-navigation')).backgroundColor.replace(/\s/g, '') === 'rgb(0,32,84)';
			const isHeaderWhite = window.getComputedStyle(document.getElementById('header')).backgroundColor.replace(/\s/g, '').match(/^rgb\(255,255,255\)$|^rgba\(255,255,255,/);
			
			if (!isBgColor002054 && !isHeaderWhite) {
				this.style.setProperty('filter', this.style.getPropertyValue('filter') === 'invert(100%)' ? 'initial' : 'invert(100%)', 'important');
			}
		});
	}
    var logo = document.querySelector(".custom-logo");
    
    // Utilisez des chemins relatifs pour les images du logo
    var blueLogoPath = "/wp-content/uploads/2024/09/logo-cyril-reno-bleu-e1727000277271";
    var whiteLogoPath = "/wp-content/uploads/2024/09/logo-cyril-reno-blanc-e1727000291252";

    function updateSrcset(srcset, oldPath, newPath) {
        return srcset.split(', ').map(function(src) {
            return src.replace(oldPath, newPath);
        }).join(', ');
    }

    function updateLogo(newPath) {
        var oldPath = logo.src.includes("bleu") ? blueLogoPath : whiteLogoPath;
        var newSrc = window.location.origin + newPath + ".png";
        
        if (logo.src !== newSrc) {
            logo.style.opacity = 0;
            
            // Mettre à jour src
            logo.src = newSrc;
            
            // Mettre à jour srcset
            if (logo.srcset) {
                logo.srcset = updateSrcset(logo.srcset, oldPath, newPath);
            }
            
            // Mettre à jour les sources dans le picture parent si existant
            var picture = logo.closest('picture');
            if (picture) {
                picture.querySelectorAll('source').forEach(function(source) {
                    if (source.srcset) {
                        source.srcset = updateSrcset(source.srcset, oldPath, newPath);
                    }
                });
            }
            
            logo.style.opacity = 1;
        }
    }

    var headroom = new Headroom(header, {
		offset: 1,
        tolerance: {
            up: 5,
            down: 0  
        },
        classes: {
            initial: "headroom",
            pinned: "headroom--pinned",
            unpinned: "headroom--unpinned",
            top: "headroom--top",
            notTop: "headroom--not-top"
        },
        onNotTop: function() {
			if (siteNavigationCategory) 
			{
				var links = document.querySelectorAll('.category #header .site-navigation .inner .menu nav>ul>li>a:not(.button), #header .site-navigation .inner .menu nav>ul>li>span:not(.button)');
				links.forEach(function(link) {
					link.style.setProperty('color', 'black', 'important');
					link.style.setProperty('border-color', 'black', 'important');
				});
				siteNavigationCategory.style.setProperty('background-color', 'rgb(255, 255, 255)', 'important');
				updateLogo(blueLogoPath);
			}
			
        },
        onPin: function() {
            header.style.backgroundColor = 'rgb(255, 255, 255)';
			if (icon) icon.style.setProperty('filter', 'invert(0%)', 'important');
			if (siteNavigationSingle) siteNavigationSingle.style.setProperty('background-color', 'rgb(255, 255, 255)', 'important');
			if (siteNavigationCategory) siteNavigationCategory.style.setProperty('background-color', 'rgb(255, 255, 255)', 'important');

            var links = document.querySelectorAll('#header .site-navigation .inner .menu nav>ul>li>a:not(.button), #header .site-navigation .inner .menu nav>ul>li>span:not(.button)');
            links.forEach(function(link) {
                link.style.setProperty('color', 'black', 'important');
                link.style.setProperty('border-color', 'black', 'important');
            });
            updateLogo(blueLogoPath);
        },
        onTop: function() {
            header.style.backgroundColor = 'transparent';
			if (icon) icon.style.setProperty('filter', 'invert(100%)', 'important');
			if (siteNavigationSingle) siteNavigationSingle.style.setProperty('background-color', '#002054', 'important');
			if (siteNavigationCategory) siteNavigationCategory.style.setProperty('background-color', '#002054', 'important');
            var links = document.querySelectorAll('#header .site-navigation .inner .menu nav>ul>li>a:not(.button), #header .site-navigation .inner .menu nav>ul>li>span:not(.button)');
            links.forEach(function(link) {
                if (window.innerWidth > 1024) {
                    link.style.setProperty('color', 'white', 'important');
                    link.style.setProperty('border-color', 'white', 'important');
                } else {
                    link.style.setProperty('color', 'black', 'important');
					link.style.setProperty('border-color', 'black', 'important');
                }
            });
            updateLogo(whiteLogoPath);
        }
    });
    headroom.init();

	document.querySelectorAll("a[href^='#'], button[data-anchor]").forEach(element => {
		element.addEventListener("click", function(e) {
			e.preventDefault();
				headroom.unpin();
	
			const target = this.tagName.toLowerCase() === 'a' ? 
				document.querySelector(this.getAttribute("href")) : 
				document.querySelector(this.getAttribute("data-anchor"));
			smoothScroll(target);
	
			const menu = this.closest(".menu");
			if (menu) {
				document.querySelectorAll(".menu, .opener").forEach(el => el.classList.remove("active"));
				document.body.style.overflow = "visible";
			}
		});
	});

    window.addEventListener("load", function() {
        if (window.scrollY > 0) {
            headroom.unpin();
            header.style.backgroundColor = 'rgb(255, 255, 255)';
            var links = document.querySelectorAll('#header .site-navigation .inner .menu nav>ul>li>a:not(.button), #header .site-navigation .inner .menu nav>ul>li>span:not(.button)');
            links.forEach(function(link) {
                link.style.setProperty('color', 'black', 'important');
                link.style.setProperty('border-color', 'black', 'important');
            });
            updateLogo(blueLogoPath);
        }
    });
});


function smoothScroll(target) {
    if (target) {
        const startPosition = window.pageYOffset;
        const targetPosition = target.getBoundingClientRect().top + startPosition;
        const distance = targetPosition - startPosition;
        let startTime = null;

        function animation(currentTime) {
            if (startTime === null) startTime = currentTime;
            const timeElapsed = currentTime - startTime;
            const run = ease(timeElapsed, startPosition, distance, 1000);
            window.scrollTo(0, run);
            if (timeElapsed < 1000) requestAnimationFrame(animation);
        }

        function ease(t, b, c, d) {
            t /= d / 2;
            if (t < 1) return c / 2 * t * t + b;
            t--;
            return -c / 2 * (t * (t - 2) - 1) + b;
        }

        requestAnimationFrame(animation);
    }
}



document.addEventListener('wpcf7mailsent', function(event) {
    let form = event.target;

    form.style.transition = 'opacity 0.4s ease-out, height 0.6s ease-out, margin 0.6s ease-out';
    form.style.overflow = 'hidden';
    form.style.opacity = '0';
    form.style.height = `${form.offsetHeight}px`;

    requestAnimationFrame(() => {
        form.style.height = '0';
        form.style.margin = '0';
    });

    setTimeout(() => form.style.display = 'none', 600);

    let confirmationMessage = document.createElement('div');
    confirmationMessage.className = 'cf7-confirmation-message';
    confirmationMessage.textContent = 'Merci ! Votre message a été envoyé avec succès. Nous vous répondrons dans les plus brefs délais.';

    Object.assign(confirmationMessage.style, {
        fontSize: '18px',
        color: '#FFFFFF',
        backgroundColor: '#4CAF50',
        padding: '20px',
        textAlign: 'center',
        marginTop: '20px',
        borderRadius: '5px',
        opacity: '0',
        transition: 'opacity 0.8s ease-out',
        position: 'relative'
    });

    form.parentNode.insertBefore(confirmationMessage, form);
    requestAnimationFrame(() => confirmationMessage.style.opacity = '1');

    if (window.innerWidth < 768) {
        setTimeout(() => {
            let headerHeight = 400; // Récupère la hauteur du header fixe
            let messagePosition = confirmationMessage.getBoundingClientRect().top + window.pageYOffset - headerHeight;

            window.scrollTo({
                top: messagePosition, 
                behavior: 'smooth'
            });
        }, 800);
    }

    if (typeof gtag === 'function') {
        gtag('event', 'form_submission', {
            'event_category': 'contact_form',
            'event_label': 'contact_form_7',
            'value': 1
        });
    }
}, false);
